var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMagnify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.1046667,12.1953333 L9.52933333,8.62 C10.2646667,7.686 10.6673333,6.54133333 10.6673333,5.33333333 C10.6673333,3.90866667 10.112,2.56933333 9.10466667,1.56266667 C8.09733333,0.554666667 6.75866667,0 5.334,0 C3.90933333,0 2.57,0.554666667 1.56333333,1.56266667 C0.555333333,2.56933333 0.000666666667,3.90866667 0.000666666667,5.33333333 C0.000666666667,6.758 0.556,8.09733333 1.56333333,9.104 C2.57,10.112 3.90933333,10.6666667 5.334,10.6666667 C6.52533333,10.6666667 7.654,10.2733333 8.582,9.55733333 L12.1626667,13.138 L13.1046667,12.1953333 Z M2.506,8.16133333 C1.75,7.406 1.334,6.402 1.334,5.33333333 C1.334,4.264 1.75,3.26066667 2.506,2.50533333 C3.26133333,1.74933333 4.26533333,1.33333333 5.334,1.33333333 C6.40266667,1.33333333 7.40666667,1.74933333 8.162,2.506 C8.918,3.26066667 9.334,4.26466667 9.334,5.33333333 C9.334,6.402 8.918,7.406 8.162,8.16133333 C7.40666667,8.91733333 6.40266667,9.33333333 5.334,9.33333333 C4.26533333,9.33333333 3.26133333,8.91733333 2.506,8.16133333 Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnify);
export default __webpack_public_path__ + "static/media/magnify.b6f51386dad62dda46bf55365ba792a2.svg";
export { ForwardRef as ReactComponent };